/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ClinicRequestStatus } from "./ClinicRequestStatus";
import type { ClinicRequestType } from "./ClinicRequestType";
import type { PaymentMode } from "./PaymentMode";
import type { VisitProgram } from "./VisitProgram";
import type { VisitType } from "./VisitType";

/**
 * Pydantic schema for ClinicRequest API responses
 */
export interface ClinicRequestModel {
  /** Unique identifier for the clinic request */
  id: string;
  /** ID of the user who created the request */
  user_id: string;
  /** Type of clinic request */
  type: ClinicRequestType;
  /** Program associated with this visit request */
  program?: VisitProgram | null;
  /** Bookable visit type when it is known for this request */
  visit_type?: VisitType | null;
  /** Current status of the request */
  status: ClinicRequestStatus;
  /** ID of the conversation that originated this request */
  origin_conversation_id: string;
  /** Associated encounter ID */
  encounter_id?: string | null;
  /** ID of the clinic conversation created for this request */
  created_clinic_conversation_id?: string | null;
  /** Topic/condition for the request */
  topic?: string | null;
  /** Whether the clinic request has expired */
  is_expired: boolean;
  /** How the visit was paid for ('insurance' | 'cash'), stamped at visit-start. */
  payment_mode?: PaymentMode | null;
  /** Vendor-neutral id of the eligibility check run the price was based on, for an insurance-paid visit. */
  insurance_eligibility_check_id?: string | null;
}
